import CMSChildrenContainer from '@/cmsComponents/ChildrenContainer';
import { Alignment } from '@/cmsComponents/constants';
import cmsStyles from '@/cmsComponents/style.module.scss';
import React from 'react';
import { IVideoText } from 'types/cms';

import Typography from '@material-ui/core/Typography';

import { Item } from './item';
import styles from './style.module.scss';

export enum VideoTextStyle {
  VideoLeft = 'Two_Column_Video_Left',
  FullWidth = 'Full_Width',
  FiveOfSixWidth = 'One_Column',
}

interface IProps {
  heading?: string;
  layout: VideoTextStyle;
  alignment: Alignment;
  video_collection?: IVideoText;
}

export const CMSVideoText: React.FC<IProps> = ({
  video_collection,
  layout,
  alignment,
  heading,
}) => {
  return (
    <CMSChildrenContainer>
      <div className={cmsStyles.containerMarginS}>
        {video_collection && (
          <div className={styles[layout]}>
            {heading && (
              <Typography variant="h4" component="h2" className={styles.heading}>
                {heading}
              </Typography>
            )}
            <Item data={video_collection} style={layout} alignment={alignment} />
          </div>
        )}
      </div>
    </CMSChildrenContainer>
  );
};
